export const userAgreementConfig = {
	template_new_protocol_20220427: `<div style='overflow-x: hidden;'>
	<p style="margin:0pt; orphans:0; text-align:center; widows:0">
		<span style="font-family:Calibri; font-size:14pt; font-weight:bold"> </span>
		<span style="font-family:宋体; font-size:14pt; font-weight:bold">“{{productName}}”</span>
		<span style="font-family:宋体; font-size:14pt; font-weight:bold">用户协议</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
	</p>
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">特别提示</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">您务必审慎阅读、充分理解本协议中的各条款内容，特别是免除或限制责任条款、法律适用条款和争议解决条款等以及我们以加粗形式重点提示您阅读的内容，如您对协议有任何疑问，可向我们致函咨询。</span>
	</p>
	<ol type="1" style="margin:0pt; padding-left:0pt">
		<li style="font-family:Calibri; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
			<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">本协议各条款前关键词系便于您阅读和理解而设置，不代表相关条款实际内容，请您务必仔细阅读并理解本协议项下约定内容的具体含义后再使用本应用并继续相应操作。</span>
		</li>
	</ol>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">您在本应用注册账号、通过第三方账号授权登录或以其他方式使用本应用即表示您已充分阅读、理解并接受本协议的全部内容，并在自愿在与我们订立本协议前提下使用本应用服务，接受我们为您提供服务。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您不理解、不同意本协议项下全部或部分的任何约定，请您立即停止注册或登录。</span>
	</p>

	<!-- 1 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">一、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">定义</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">1.1 我们：指本应用开发者，即</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">{{companyFullName}}</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">，亦称“我司”。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">1.2 本应用：即我们开发并发布的名为</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">{{productName}}</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">的应用。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">1.3 用户：具备用户资格在且本应用登录、注册并接受我们服务的自然人，即本协议中的“您”。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">1.4 奖励：本应用内可按规则被兑换为现金、现金形式奖励或其他物质奖励的数值，表现形式不限于红包、元宝、分数、钻石等。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">1.5 兑换：将在本应用内所获奖励按规则、一定比例兑换为现金、现金形式奖励或其他物质奖励的行为，本应用或协议中又称“提现”。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">1.6 广告：指宣传产品或服务的相关内容，用户可自愿点击广告出现位置了解相关信息。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">1.7 任务：指用户为获得奖励、兑换、等级提升等奖励所需要完成的条件，具体条件由我们发布、制定并以适当形式展示。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">1.8 规则：指我们不时发布并修订的关于本应用的用户守则、玩家条例、游戏公告、提示及通知等内容。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">1.9 页面：本应用内展示信息的相关区域，用户可在区域内滑动或点击以浏览相关信息。</span>
	</p>

	<!-- 2 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">二、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">本应用服务</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">2.1</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">获取</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您可以通过我们注册的网站或经我们授权的第三方渠道下载本应用，您应当选择合适版本的本应用进行安装。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您从未经我们授权的第三方获取本应用名称相同安装程序，我们无法保证您能够正常使用相应程序，并对因此给您造成的损失不予负责。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">2.2</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">功能</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">本应用为免费应用，无需您在应用内进行充值付费转账等操作，您在可在本应用内进行相应互动点击操作，满足一定条件时可获得奖励奖励，并按规则进行奖励兑换。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉可自愿在本应用内通过包括观看广告等方式获得不定数值的奖励，应用内所展示奖励数值不等于实际可兑换到现金、现金形式奖励或其他物质奖励的价值，具体详见本协议中兑换规则部分说明。</span>
	</p>


	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">2.3</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">更新</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">为了改善您的体验、完善本应用服务，我们将不断努力开发新服务，并有权在不向您进行特别通知的情况下为您提供本应用更新。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">若您拒绝更新本应用，我们不保证非最新版本的本应用可继续使用包括奖励兑换在内功能的使用，故请您务必随时核对并下载最新版本。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">2.4</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">广告</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉本应用内所呈现的全部广告内容均由非本协议缔结双方的第三方发布，</span>
		<span style="font-family:宋体; font-size:10.5pt">如您发现违规广告请务必向我们提供完整广告播放录屏、观看广告时间等必要信息，以便我们协调处理。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">广告中所出现非我司产品和服务概与我们无涉，用户因本应用内广告内容的交易、消费或其他操作所遭受损失由您自行承担。我们善意提示您，请务必谨慎通过广告所宣传产品或服务进行消费、转账或充值，以免利益受损。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">2.5</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">中止、变更、中断</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">我们基于经营策略的调整，可能会对服务内容进行变更，也可能会中断、中止或终止服务。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">囿于技术和市场变化无常，您理解并同意我们有权在不事先征求您同意的情况下对服务进行变更、中断、中止或终止。</span>
		<span style="font-family:宋体; font-size:10.5pt">但我们会尽力将相关信息通过我们的网站妥为告知，还请您留意我们的网站消息。</span>
	</p>






	<!-- 3 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">三、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">用户</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.1</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">注册条件</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您开始注册程序使用服务前，您确认应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.2</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">使用目的</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您应当出于非商业目的使用本应用服务，禁止任何主体通过本应用服务进行商业活动或牟取不正当利益。您理解并同意以下行为将被认为构成商业目的：</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">使用本应用同时还安装或正在使用大于等于包括但不限于本公司运营的三款含有兑换功能应用；在本应用内连续三个自然日每日观看广告视频数量超过三十条或三个自然日内累计观看广告数量超过九十条；在本应用内七日内进行奖励兑换或兑换次数超过五次；其他以牟取数额较大经济利益而使用本应用行为。</span>
	</p>


	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.3</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">用户账号</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">我们将在收到您注册申请后向您发放由字母、数字、字符等随机组成的账号，您有义务妥善保管好账号及对应密码，因您将密码透露第三方所发生损失由您自行承担。</span>
	</p>


	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.4</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">转让和共享禁止</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您所注册的本应用账号及账号内奖励仅限您个人使用，禁止向第三方有偿或无偿等任何形式转让和共享。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.5</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">用户等级</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并知悉我们将按照用户连续登录天数等用户行为动态区分用户等级，该等级将影响您的奖励获取和兑换。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.6</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">第三方工具禁止</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您不得使用第三方插件、外挂、系统、工具或其他手段从事加速升级、获取奖励、频繁申请奖励兑换或体现等可能影响本应用正常运行的行为。</span>
		<span style="font-family:宋体; font-size:10.5pt">如您使用前述手段导致无法使用本应用或造成其他损失的概与我司无涉，您将自行承担相应负面后果。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.7</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">账号注销</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">用户可以申请注销账号，公司名称会在完成个人身份、安全状态、设备信息等合理和必要的验证后协助用户注销账号，并依照用户的要求删除有关用户账号的一切信息，法律法规另有规定的除外。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.8</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">故障谅解</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您理解互联网服务可能因技术或网络故障等原因导致奖励兑换等延迟或超额向您发放，您确认自愿将因上述原因使您获取的利益退还我们，以便我们更长久地为您提供服务。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.9</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">设备和网络</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">您使用本应用全部或部分服务须使用移动设备等接入互联网，使用本应用过程中所发生的流量费、上网费、终端购置费用等由您自行承担。</span>
		<span style="font-family:宋体; font-size:10.5pt">因互联网服务不稳定而导致无法使用本应用服务的，由您自行处理。我们建议您切勿频繁更换设备或网络使用本应用，以免影响您正常登录和使用本应用。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.10</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">限制传播</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">我们对应用的全部内容享有知识产权，您确认在使用本应用过程中不得未经我们许可以任何方式录制、直播或向他人公开传播本应用内容，包括但不限于不得利用任何第三方软件进行网络直播、传播等。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.11</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">个人信息</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">保护用户个人信息及隐私是我们的一项基本原则。我们对用户个人信息收集、使用及保护等将遵循本应用《隐私协议》及具体隐私政策（如有）等协议规定。如您已同意我们依据前述协议或规定处理您个人信息又撤回同意的，根据法律规定，你撤回同意，不影响撤回前基于您同意已进行的个人信息处理活动的效力。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.12</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">用户行为</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt;">您理解并同意您的每次应用操作将被我们记录，以便后台统计您为本应用创造的价值，考虑到本应用运营开发、信息服务支持需要高昂成本，您为本应用创造价值计算方式为：用户观看广告视频为本应用带来的累计收益乘以百分之三十。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">3.13</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">连续登录</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认知悉本协议中“连续登录”的含义为连续多个自然日使用网络进入到本应用且每个自然日的零时至二十四时在本应用内观看广告等操作时长不低于十五分钟。如您在已连续登录多日后中断，则连续登录天数自中断后重新计算，中断日前已连续登录天数清零。</span>
	</p>
	<!-- 4 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">四、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">奖励</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">4.1</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">奖励性质</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您理解并同意，奖励数量仅为应用内道具，不具备任何的经济价值，奖励在成功兑换前的所有权属于我们。奖励个数仅为道具数量的展示，并非等同于最终可兑换奖品金额，能否兑换以及具体可兑换金额请您详细阅读本协议兑换规则、活动规则、任务说明等部分内容。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">4.2</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">奖励获取</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt;">我们有权依据您任务完成进度、观看广告次数、时长等因素向您随机发放不定数额的奖励，您不可向任何第三方转让本应用内奖励。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">4.3</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">奖励展示</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您认可并理解奖励所对应的数值本身不具有单位，但为便于您直观理解我们可能会在相应数值后标注“元”等汉字，相应数值后接汉字不具备任何货币或等价物的含义。为方便您了解您在本应用内获得的奖励总数，您获取但已过有效期等不可兑换奖励数值也会包含在应用内奖励数值展示的相应位置，但这并不代表所展示的奖励数值均可被实际兑换。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">4.4</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">奖励有效期</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解奖励有效期限自您获取之日起算，如您自获取之日起十五日内未完成我们为您设置的任务，则相应奖励数值不可进行使用。</span>
		<span style="font-family:宋体; font-size:10.5pt; ">您进行兑换操作时，我们会优先为您使用尚在有效期内的奖励进行兑换。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">4.5</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">兑换资格</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您同意并认可具备兑换资格是您可成功进行兑换的前提，如您欲进行兑换操作须同时满足如下条件：已全面履行本协议“三、用户”部分所述约定，不存在以商业目的使用本应用服务或以不正当手段获取奖励等违规行为；且满足兑换规则部分所描述的提现条件。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">4.6</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">数值展示</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt;">应用内奖励处所显示数值并非实际可兑换数值，该数值系通过已获得奖励数值减去已兑换和消耗奖励数值得出。您同意具体可兑换数值数量以您提交兑换申请后审核通过的数量为准。</span>
	</p>

	<!-- 5 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">五、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">兑换</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">5.1</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">兑换性质</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">兑换系我们向完成特定任务用户发放奖励的行为，本应用处于盈利状态且您的用户行为创造价值不低于提现金额是我们为您兑换奖励的前提条件之一。因此您的用户行为将影响最终实际兑换金额，如您的用户行为无法为本应用带来收益，我们有权拒绝您的兑换申请。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">5.2</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">兑换参与</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt;">您在本应用内提交首次兑换申请或兑换相应奖励的操作即视为您自愿参与我们的兑换活动并同意本协议及兑换页面相关规则约束，且完全理解相关内容。如您认为我们设置的兑换规则、条件等不合理，请在注册和登录后不要进行任何兑换、提现操作。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">5.3</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">可兑价值</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并理解，我们会按照您的用户行为对兑换价值进行限制。我们提示您请务必在尚满足相应条件的情况下，进行相应兑换操作。如您在满足相应等级时未进行兑换操作，则您需要再次等到用户等级符合兑换限制时再向我们申请兑换。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">5.4</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">兑换申请</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认将在具备兑换资格且完成本应用内设置的任务时，在不高于用户等级所对应的最高可兑换价值范围内，</span>
		<span style="font-family:宋体; font-size:10.5pt;">在应用内点击“立即提现”或“全部提现”等类似字样发起兑换申请。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并同意依法纳税是每位公民的义务，我们有权依据国家法律规定为您按实际累计已兑换金额进行个人所得税申报和代扣代缴，如您拒绝纳税申报则视为您放弃兑换，未主动向我们提供必要信息进行纳税申报的视为放弃兑换。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">5.5</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">兑换审核</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt;">我们会在收到您的兑换申请后尽快为您处理，</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">处理时间不超过30个工作日。如您不满足用户等级、兑换规则、应用内界面所述兑换条件等条件下提交兑换申请，我们有权拒绝为您进行兑换。如您兑换申请被我们拒绝，还请您提交包括但不限于用户ID、待兑换奖励数值等信息以便我们为您核实您兑换申请被拒绝原因，如您拒绝提供相关信息的视为您自愿放弃兑换。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">5.6</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">兑换发放</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您确认并同意奖励可兑换价值将发放至您授权登录本应用的已实名认证微信，某些特殊情况下我们会在妥为告知您后通过其他途径发放。</span>
		<span style="font-family:宋体; font-size:10.5pt;">如您因微信账号实名认证或拒绝向我们提供其他兑换途径而导致无法成功兑换的，视为您自愿放弃兑换。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您理解并同意，我们有权以现金形式发起转账或其他价值相等的购物平台优惠券、实物礼品等，具体以实际发放为准。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">5.7</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">兑换放弃</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt;">您理解并同意如您自行注销本应用账号、连续二十日未登录本应用账号，则视为您已自愿放弃账号内全部已获得奖励，并不再向我们提出兑换申请或任何使用奖励的请求；如您十日内未完成我们设置的相应任务即视为放弃完成相应任务，即便您在放弃后又完成了相应任务，我们将有权拒绝向您兑换相应任务奖励。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">5.8</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">兑换查询</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt;">我们承诺严守本协议约定向用户进行奖励兑换，出于商业秘密保护和个人隐私保护需求，我们不支持您查询包括自己行为在内的信息。</span>
	</p>
	<!-- 6 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">六、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">活动规则及任务说明</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">6.1</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">活动规则</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您首次一经兑换成功奖励即视为理解并同意参与本活动，自愿接受奖励规则、兑换规则以及本活动规则约束。如您对本应用内活动设置有任何不明或疑问，请拒绝领取我们发放的奖励。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">6.2</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">活动性质</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您理解并同意，本活动性质为悬赏广告，您只有在完成指定任务的情况下，才能向活动方申请发放对应奖励。如您未满足活动要求、未在时限内完成相应任务或存在违规行为的，我们将无法为您兑换奖励。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">6.3</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">任务说明</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
	</p>
	{{cashConfig}}

	<!-- 7 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">七、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">违约处理</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">7.1</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">商业目的和不正当手段</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">如您出于商业目的注册并使用本应用服务或通过任何技术手段、以及任何非真实自然人的手段点击广告、作弊手段等行为使用本应用服务，我们有权封禁您账号、禁用应用全部或部分功能、收回已发放全部奖励、收回已兑换奖励。</span>
		<span style="font-family:宋体; font-size:10.5pt">前述行为包括但不限于擅自更改平台之软件程序、通过刷机刷量等技术手段或使用黑客手段等类似手段攻击公司名称服务器及其他不正当手段。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">7.2</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">违规行为</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您通过任何不正当手段骗取奖励的，我们将拒绝进行兑换并有权停止您使用本应用服务，不正当手段包括：批量注册账号或出于非正常使用目的注册账号、养号、买号；从事赌博、违规套现、洗钱等扰乱市场秩序的；使用外挂或其他技术手段屏蔽广告、跳过广告播放、虚假点击广告的；使用外挂借助非自然流量、非正常社交关系（如助力群）完成任务的；明确不符合活动规则兑换条件，但多次反复联系我们要求进行兑换的；其他不符合本协议约定、活动规则以及诚实信用的行为。您理解并同意，违规行为由我们根据根据正常用户操作习惯、其他同类应用数据、广告主反馈以及您在本应用内的行为进行综合判定。</span>
	</p>
	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">7.3</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">不得侵害本应用权利</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">任何人未经我们同意不得从事以下行为：</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">删除软件及其副本上关于著作权的信息；对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；对我们拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经我们授权的第三方工具/服务接入软件和相关系统；通过修改或伪造软件运行中的指令、数据等任何方式，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；通过非我们开发、授权的第三方软件、插件、外挂、系统、设备等任何方式，登录或使用我们软件及服务，或制作、发布、传播非我们开发、授权的用于登录或使用我们软件及服务的第三方软件、插件、外挂、系统、设备等；不得散布不实言论损害我们名誉。</span>
		<span style="font-family:宋体; font-size:10.5pt">如因上述行为给我们造成损失，您应承担相应侵权责任，并赔偿我们所受损失。</span>
	</p>
	<!-- 8 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">八、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">不可抗力和免责事由</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">8.1</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">不可抗力</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失我们在法律允许的范围内免责。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">8.2</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">技术故障免责</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">在法律允许的范围内，我们对以下情形导致的服务中断或受阻不承担责任：受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；用户或我们的电脑软件、系统、硬件和通信线路出现故障；用户操作不当或用户通过非我们授权的方式使用本服务；程序版本过时、设备的老化和/或其兼容性问题；其他我们无法控制或合理预见的情形。/或其兼容性问题；其他我们无法控制或合理预见的情形。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">8.3</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">外来风险免责</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。</span>
		<span style="font-family:宋体; font-size:10.5pt">这些风险包括但不限于：来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；其他因网络信息或用户行为引起的风险。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">8.4</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">违规处理免责</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">我们依据本协议约定获得处理违法违规内容的权利，该权利不构成义务或承诺，我们不能保证及时发现违法行为或进行相应处理。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">8.5</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">第三方消费免责</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">本应用内不设任何充值和打款渠道，也无须用户通过第三方应用向我们付费。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">您在第三方处进行任何消费，我们均不承担任何责任，包括但不限于：为加速完成本应用设定任务向第三方付费；通过本应用内广告进行消费等。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">8.6</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">涉财产行为免责</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">涉及财产操作的，请一定先核实对方身份，并请经常留意有关部门防范诈骗犯罪的宣传和提示。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">8.7</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">非可控故障免责</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">我们可能因BUG、版本更新缺陷、第三方病毒攻击或其他任何因素导致您的账号数据发生异常。</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">在数据异常的原因未得到查明前，我们有权暂停您使用账号；若查明数据异常为非正常行为所致，我们有权恢复游戏账号数据至异常发生前的原始状态（包括向第三方追回被转移数据），而无须向您承担任何责任。若数据异常是由于您实施违法违规行为或违反本协议约定的行为所致，我们有权采取本协议“违约处理”部分一种或多种处理措施。</span>
	</p>


	<!-- 9 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">九、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">其他条款</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">9.1</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">协议生效和争议解决</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">本协议于您于我司注册地签订，并于您在开始使用本协议之时起正式生效，您与我们因本应用所产生的任何争议均由北京仲裁委员会管辖。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">9.2</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">知识产权声明</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表、计算机软件等）的知识产权归我们所有。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">9.3</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">协议修订</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们有权在网站上随时发布本协议的修订版本，一经发布即视为已经送达于您。如您不同意我们对协议的修订，您可以选择停止使用我们为您提供的服务或注销已注册的本应用账号，否则即视为您完全同意我们的修改</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">9.4</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">协议性质</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您确认本协议系您作为用户与我司平等订立的用户协议，奖励及兑换系您在完成任务且符合我们制定规则的前提下向您进行的免费奖励，而非任何形式的报酬，您与我司不存在任何形式的劳务或劳动关系。</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">9.5</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">【</span>
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">协议范围</span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">】</span>
		<span style="font-family:宋体; font-size:10.5pt">您确认理解并知悉，本应用的相关宣传内容非本协议组成部分，仅系说明本应用功能和扩大本应用知名度使用。我们在网站及应用内发布的公告、规则、活动说明等内容为本协议不可分割之组成部分，请您务必留意查看。</span>
	</p>


	<!-- 联系我们 -->
	<p style="margin:7.8pt 0pt; orphans:0; text-align:justify; text-indent:0pt; widows:0">
		<span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">十、</span>
		<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
		<span style="font-family:宋体; font-size:10.5pt; font-weight:bold">联系我们</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">地址：</span>
		<span style="font-family:宋体; font-size:10.5pt">{{address}}</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">网站：</span>
		<span style="font-family:宋体; font-size:10.5pt">{{officialWebsite}}</span>
	</p>

	<p style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
		<span style="font-family:宋体; font-size:10.5pt">邮箱：</span>
		<span style="font-family:宋体; font-size:10.5pt">{{mail}}</span>
	</p>
</div>`,
}
